import Header from "../components/Header"
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { useEffect, useState } from "react";


export const MainCategories = () => {
    const { language } = useLanguage();
    const [data, setData] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        fetch(`/assets/data.json?_=${Date.now()}`)
            .then(res => res.json())
            .then(setData);
    }, []);

    if (!data) return <div class="text-white font-bold w-full text-align">Loading...</div>;

    const goToCategory = (category) => {
        if (category.hasSubcategories) {
            navigate(`/menu-categorias/${category.id}`);
        } else {
            navigate(`/menu-categorias/${category.id}/items`);
        }
    };

    return (
        <div className="">
            <Header />

            {/* Heading + Back Link */}
            <div className="p-4 flex items-center justify-between mt-4">
                <button onClick={() => navigate(-1)} className="text-black px-2 hover:bg-gray-300 relative z-10 bg-white rounded">
                    ← {language === 'en' ? 'Back' : 'Voltar'}
                </button>
                <h1 className="text-3xl font-bold text-white text-center absolute w-full right-0">
                    {language === 'en' ? 'Main Menu' : 'Menu'}
                </h1>
            </div>
            <ul className='flex flex-wrap flex-row'>
                {data.categories.map((cat) => (
                    <li className="w-full md:w-6/12 lg:w-4/12 px-2" key={cat.id}>
                        <button className="w-full" onClick={() => goToCategory(cat)}>
                            <div className="p-5 my-4 border-2 border-b-8 border-[#33525a] rounded-xl">
                                <p className='item-name-heading text-white mb-4 text-5xl'><b>{cat.name[language]}</b></p>
                            </div>
                        </button>
                    </li>
                ))}
            </ul>
        </div >
    )
}